import { VALUES, VALUES_3 } from '../utils/values/cats'
import { RANKING } from '../context/types'
import { DEFAULT_AUTH_STATE } from '../context/defaultState'

export type AssignedBuckets = Record<VALUES, RANKING>; //TODO hasPower and 7 buckets, i.e. VALUES_3 

export type AssessmentDTO = AssignedBuckets & {
    slug?: string
    source?: string
    from: (typeof DEFAULT_AUTH_STATE)['from']
    // appVersion?: string // FIXME
} & {
    startDate: string
    endDate: string
    durationSeconds: number
}

export type ErrorPayload =
    | { error: { code: string; message: string } }
    | undefined

export type QueryParams = {
    token?: string
    a?: string
    b?: string
    email: string
    slug: string
    source: string
    language: string
    from: (typeof DEFAULT_AUTH_STATE)['from']
}

export const OCODES = {
    OK: { status: 200, key: 'OK' },
    UNAUTHORIZED: { status: 401, key: 'UNAUTHORIZED' },
    BAD_REQUEST: { status: 400, key: 'BAD_REQUEST' },
    DUPLICATE_ENTRY: {
        status: 400,
        code: 'ER_DUP_ENTRY',
        key: 'DUPLICATE_ENTRY',
    }, // FIXME
    VALIDATION_ERROR: {
        status: 400,
        code: 'VALIDATION',
        key: 'VALIDATION_ERROR',
    }, // FIXME
    INTERNAL_SERVER_ERROR: { status: 500, key: 'INTERNAL_SERVER_ERROR' },
    UNKNOWN: { key: 'UNKNOWN' },
} as const

export type OCODES_TYPE = (typeof OCODES)[keyof typeof OCODES]['key']

export type SUBCODES = 'ER_DUP_ENTRY' | 'VALIDATION' | 'ERROR' | 'OK' // FIXME

export const FINAL_NPS_KEY = 'final_nps';
export const NO_SCORE = -1;
export type AnswserScoreType = {
    RefQuestion: VALUES | typeof FINAL_NPS_KEY
    Score: typeof NO_SCORE | 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11
    Comment?: string
}
export type Scanning360Request = {
    BeginDateHour: string
    EndDateHour: string
    IDUser: string
    JWTToken: string
    Language: string
    Email: string
    Slug: string
    Source: string
    AnswerScore: AnswserScoreType[]
} & {
    durationSeconds?: number
    // FIXME
    userAgent?: string
    language?: string
}

export type ProfileData = {
    email: string
    currentCompanySlug: string
    currentSource?: string //FIXME clickup
    // TODO currentFrom: string
    exp?: number
    iat?: number
    sub: string
}
